"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIMARY_ID_TYPE = void 0;
exports.getPropertyScopedIdentificationTypes = getPropertyScopedIdentificationTypes;
exports.getIdentificationTypeOptions = getIdentificationTypeOptions;
exports.getSelectedIdentificationTypeFallbackOptions = getSelectedIdentificationTypeFallbackOptions;
exports.getIdentificationTypeAvailabilityIssues = getIdentificationTypeAvailabilityIssues;
exports.getIdentificationTypeConfig = getIdentificationTypeConfig;
var entities_1 = require("@common/entities");
var ID_TYPES_1 = require("./ID_TYPES");
Object.defineProperty(exports, "PRIMARY_ID_TYPE", { enumerable: true, get: function () { return ID_TYPES_1.PRIMARY_ID_TYPE; } });
var normalize = function (value) { return value.trim().replace(/\s+/g, ' ').toLowerCase(); };
function getPropertyScopedIdentificationTypes(types, properties) {
    return types.map(function (type) {
        var unavailableProperties = properties.filter(function (property) { return !type.property_ids.includes(property.propertyId); });
        return __assign(__assign({}, type), { isDisabled: unavailableProperties.length > 0, unavailablePropertyNames: unavailableProperties.map(function (property) { return property.propertyName; }), disabledReason: unavailableProperties.length > 0
                ? "This ID type is not configured for: ".concat(unavailableProperties
                    .map(function (property) { return property.propertyName; })
                    .join(', '), ".")
                : undefined });
    });
}
function getIdentificationTypeOptions(types, selectedValues) {
    if (types === void 0) { types = []; }
    if (selectedValues === void 0) { selectedValues = []; }
    var selectedValueSet = new Set(selectedValues);
    var dynamicTypes = types
        .map(function (type) { return ({
        value: String(type.id),
        label: type.name,
        isDisabled: type.isDisabled && !selectedValueSet.has(String(type.id)),
        disabledReason: type.disabledReason,
    }); })
        .filter(function (type, index, values) { return values.findIndex(function (item) { return item.value === type.value; }) === index; });
    return dynamicTypes;
}
function getSelectedIdentificationTypeFallbackOptions(selectedTypes, availableOptions) {
    if (selectedTypes === void 0) { selectedTypes = []; }
    if (availableOptions === void 0) { availableOptions = []; }
    var availableValues = new Set(availableOptions.map(function (option) { return option.value; }));
    var fallbackOptions = new Map();
    selectedTypes.forEach(function (selectedType) {
        var value = selectedType.identificationTypeId
            ? String(selectedType.identificationTypeId)
            : selectedType.customType;
        if (!value || availableValues.has(value))
            return;
        fallbackOptions.set(value, {
            value: value,
            label: selectedType.displayName ||
                selectedType.label ||
                selectedType.name ||
                selectedType.customType ||
                value,
        });
    });
    return Array.from(fallbackOptions.values());
}
function getIdentificationTypeAvailabilityIssues(selectedTypes, availableTypes) {
    if (selectedTypes === void 0) { selectedTypes = []; }
    if (availableTypes === void 0) { availableTypes = []; }
    var issues = new Map();
    selectedTypes.forEach(function (selectedType) {
        var _a, _b;
        if (selectedType.taxIdTypeId || selectedType.customType === entities_1.IDTypes.SocialSecurityNumber) {
            return;
        }
        var id = Number(selectedType.identificationTypeId);
        var names = [
            selectedType.displayName,
            selectedType.label,
            selectedType.name,
            selectedType.customType,
        ].filter(function (value) { return Boolean(value); });
        var availableType = id
            ? availableTypes.find(function (type) { return type.id === id; })
            : availableTypes.find(function (type) {
                return names.some(function (name) { return normalize(type.name) === normalize(name); });
            });
        var label = (_a = names[0]) !== null && _a !== void 0 ? _a : "Identification type ".concat(id);
        var key = id ? "id:".concat(id) : "name:".concat(normalize(label));
        if (!availableType) {
            issues.set(key, {
                key: key,
                label: label,
                message: 'No longer available in the company identification-type configuration',
            });
            return;
        }
        if (availableType.isDisabled) {
            var propertyNames = (_b = availableType.unavailablePropertyNames) !== null && _b !== void 0 ? _b : [];
            var propertyLabel = propertyNames.length === 1 ? 'property' : 'properties';
            issues.set(key, {
                key: key,
                label: label,
                message: propertyNames.length
                    ? "Unavailable for ".concat(propertyLabel, " \u201C").concat(propertyNames.join('”, “'), "\u201D")
                    : 'Unavailable for one or more properties',
            });
        }
    });
    return Array.from(issues.values());
}
function getIdentificationTypeConfig(value, label, types) {
    var _a, _b, _c, _d, _e, _f;
    if (types === void 0) { types = []; }
    var apiType = types.find(function (type) { return String(type.id) === value || normalize(type.name) === normalize(value); });
    var knownEntry = Object.entries(ID_TYPES_1.ID_TYPE_ENUM_MAPPING).find(function (_a) {
        var key = _a[0], config = _a[1];
        return normalize(key) === normalize(value) ||
            normalize(config.name) === normalize(value) ||
            normalize(config.label) === normalize(value) ||
            normalize(config.customType) === normalize(value);
    });
    var knownConfig = apiType
        ? (0, ID_TYPES_1.getIdentificationTypeTemplateBySystemCode)(apiType.system_code)
        : ((_a = knownEntry === null || knownEntry === void 0 ? void 0 : knownEntry[1]) !== null && _a !== void 0 ? _a : (0, ID_TYPES_1.getIdentificationTypeTemplate)(value));
    var resolvedLabel = (_b = apiType === null || apiType === void 0 ? void 0 : apiType.name) !== null && _b !== void 0 ? _b : label;
    if (knownConfig) {
        return __assign(__assign(__assign(__assign({}, knownConfig), { customType: value }), (apiType
            ? { identificationTypeId: apiType.id, displayName: resolvedLabel, label: resolvedLabel }
            : {})), ((apiType === null || apiType === void 0 ? void 0 : apiType.system_code) ? { systemCode: apiType.system_code } : {}));
    }
    var fallbackConfig = (_c = (0, ID_TYPES_1.getIdentificationTypeTemplateBySystemCode)(apiType === null || apiType === void 0 ? void 0 : apiType.system_code)) !== null && _c !== void 0 ? _c : (0, ID_TYPES_1.getIdentificationTypeTemplate)('other_misc_identification');
    return __assign(__assign(__assign(__assign(__assign({}, fallbackConfig), { name: (_d = fallbackConfig === null || fallbackConfig === void 0 ? void 0 : fallbackConfig.name) !== null && _d !== void 0 ? _d : 'other_misc_identification', label: resolvedLabel, displayName: resolvedLabel, 
        // Keep the API identification-type ID as the persisted value. The
        // Other/Misc template is selected independently for rendering.
        customType: value }), (apiType ? { identificationTypeId: apiType.id } : {})), ((apiType === null || apiType === void 0 ? void 0 : apiType.system_code) ? { systemCode: apiType.system_code } : {})), { elementType: (_e = fallbackConfig === null || fallbackConfig === void 0 ? void 0 : fallbackConfig.elementType) !== null && _e !== void 0 ? _e : 'block', fields: (_f = fallbackConfig === null || fallbackConfig === void 0 ? void 0 : fallbackConfig.fields) !== null && _f !== void 0 ? _f : ID_TYPES_1.ID_TYPE_ENUM_MAPPING[entities_1.IDTypes.DriversLicense].fields });
}
